import type { LandingContent } from '../../shared/content/landingContent.js';
import type { LandingEditorElementDefinition } from './landingEditorRegistry.js';

export const companyPeopleHeroEditorDefinitions = (content: LandingContent): LandingEditorElementDefinition[] => {
  const definitions: LandingEditorElementDefinition[] = [];
  const section = 'companyPeopleHero' as const;
  const container = (
    id: string,
    label: string,
    parentId = `section.${section}`,
    repeat?: { path: string; index: number },
  ) =>
    definitions.push({
      id,
      label,
      section,
      kind: 'container',
      parentId,
      ...(repeat ? { repeatPath: repeat.path, repeatIndex: repeat.index } : {}),
    });
  const field = (
    path: string,
    label: string,
    kind: 'text' | 'image' | 'url' = 'text',
    parentId = `section.${section}`,
  ) =>
    definitions.push({
      id: path,
      path,
      label,
      section,
      kind,
      parentId,
      typographyMode:
        path.endsWith('.motion') || path.endsWith('.imageAlt') || path.endsWith('.scrollLabel')
          ? 'none'
          : /\.(title|intro|text)$/.test(path)
            ? 'semantic'
            : 'visual',
    });
  container(`${section}.copy`, 'Menschen-Hero: Einstieg');
  container(`${section}.people`, 'Menschen-Hero: Porträtblasen');
  container(`${section}.contact`, 'Menschen-Hero: Enes & Sprechblasen');
  container(`${section}.actions`, 'Menschen-Hero: Sprechblasen', `${section}.contact`);
  container(`${section}.benefits`, 'Menschen-Hero: Fakten');
  for (const [key, label] of Object.entries({
    title: 'Überschrift',
    highlight: 'Hervorgehobener Text',
    intro: 'Kurze Einleitung',
    scrollLabel: 'Scroll-Pfeile: Beschriftung für Screenreader',
    motion: 'Animation: subtle oder off',
  }))
    field(
      `${section}.${key}`,
      `Menschen-Hero: ${label}`,
      'text',
      ['title', 'highlight', 'intro'].includes(key) ? `${section}.copy` : `section.${section}`,
    );
  field(`${section}.portrait.image`, 'Menschen-Hero: Enes', 'image', `${section}.contact`);
  field(`${section}.introAction.label`, 'Einstieg: Buttontext zum Unternehmenstool', 'text', `${section}.copy`);
  field(`${section}.introAction.href`, 'Einstieg: Button-Linkziel', 'url', `${section}.copy`);
  field(`${section}.portrait.imageAlt`, 'Enes: Alternativtext', 'text', `${section}.contact`);
  for (const key of ['primaryAction', 'secondaryAction'] as const) {
    field(
      `${section}.${key}.label`,
      key === 'primaryAction' ? 'Untere Sprechblase: Text' : 'Obere Sprechblase: Text',
      'text',
      `${section}.actions`,
    );
    field(`${section}.${key}.href`, 'Sprechblase: Linkziel', 'url', `${section}.actions`);
  }
  content.companyPeopleHero.people.forEach((_, index) => {
    const id = `${section}.people.${index}`;
    container(id, `Porträtblase ${index + 1}`, `${section}.people`, { path: `${section}.people`, index });
    field(`${id}.image`, 'Porträtbild', 'image', id);
    field(`${id}.imageAlt`, 'Alternativtext', 'text', id);
  });
  content.companyPeopleHero.benefits.forEach((_, index) => {
    const id = `${section}.benefits.${index}`;
    container(id, `Fakt ${index + 1}`, `${section}.benefits`, { path: `${section}.benefits`, index });
    field(`${id}.title`, 'Titel', 'text', id);
    field(`${id}.text`, 'Beschreibung', 'text', id);
  });
  return definitions;
};
